import { COLOR_KEYS } from '../../constants';
import { HeadingProps } from './Heading';

export const DEFAULT_VALUES: HeadingProps = {
  backgroundColor: COLOR_KEYS.neutral100,
  color: COLOR_KEYS.earth,
  isCentered: true,
  maxWidth: 'medium',
  size: 'medium',
  spacing: 'medium',
  tag: 'h2',
  text: 'Heading',
};
